import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import FormAutocomplete from "../../forms/FormAutocomplete";
import {
  Control,
  FieldErrors,
  UseFormSetValue,
  UseFormTrigger,
} from "react-hook-form";
import Tile from "../../../types/tile";
import EmailGroup from "../../../types/emailGroup";
import NotificationSchedule from "../../../types/notificationSchedule";
import NotificationSettings from "../../../types/notificationSettings";
import AlertDeliveryForm from "./AlertDeliveryForm";
import Option from "../../../types/option";

interface Props {
  control: Control<Tile, any>;
  formValues: Tile;
  emailGroups?: EmailGroup[];
  scheduledNotifications?: NotificationSchedule[];
  notificationSettings?: NotificationSettings;
  enabledNotifications: {
    threshold: boolean;
    offline: boolean;
  };
  setValue: UseFormSetValue<Tile>;
  loadWithSkeleton: (
    element: React.ReactNode,
  ) =>
    | string
    | number
    | boolean
    | Iterable<React.ReactNode>
    | JSX.Element
    | null
    | undefined;
  responderIncidentTypes: Option[];
  gmdJobTypes: Option[];
  error?: FieldErrors<Tile>;
  trigger?: UseFormTrigger<Tile>;
}

const NotificationForm: React.FC<Props> = (props) => {
  const {
    control,
    formValues,
    emailGroups,
    scheduledNotifications,
    notificationSettings,
    loadWithSkeleton,
    enabledNotifications,
    setValue,
    responderIncidentTypes,
    gmdJobTypes,
    error,
    trigger,
  } = props;

  return (
    <>
      {(enabledNotifications.offline || enabledNotifications.threshold) && (
        <>
          <Box display="flex" flexDirection="row" width="100%" mt={2}>
            <Typography fontWeight="bold">Notifications</Typography>
          </Box>
          {enabledNotifications.offline && (
            <AlertDeliveryForm
              alertKey={"offline"}
              control={control}
              notificationSettings={notificationSettings}
              setValue={setValue}
              emailGroups={emailGroups}
              loadWithSkeleton={loadWithSkeleton}
              responderIncidentTypes={responderIncidentTypes}
              gmdJobTypes={gmdJobTypes}
              error={error?.alerts?.offline?.deliveryRequired}
            />
          )}
          {enabledNotifications.threshold && (
            <AlertDeliveryForm
              alertKey={"threshold"}
              control={control}
              notificationSettings={notificationSettings}
              setValue={setValue}
              emailGroups={emailGroups}
              loadWithSkeleton={loadWithSkeleton}
              responderIncidentTypes={responderIncidentTypes}
              gmdJobTypes={gmdJobTypes}
              error={error?.alerts?.threshold?.deliveryRequired}
              trigger={trigger}
            />
          )}
        </>
      )}
      {
        // (!!formValues.type?.hasReport || !!formValues.type?.hasThreshold) &&
        !!scheduledNotifications && (
          <>
            <Box display="flex" flexDirection="row" width="100%" mt={2}>
              <Typography fontWeight="bold">Scheduled Report</Typography>
            </Box>
            <Typography variant="caption" width="100%">
              Notification Schedules are a combination of an Notification Group
              and a Schedule. To modify these, visit the Reports page or contact
              your site admin.
            </Typography>
            <Grid2 size={{ xs: 12, sm: 6 }}>
              {loadWithSkeleton(
                <FormAutocomplete
                  control={control}
                  fieldName="scheduledReport.notificationSchedules"
                  label="Report Notification Schedule"
                  options={scheduledNotifications || []}
                  multiple
                  noOptionsText="No schedules available."
                  disabled={!scheduledNotifications.length}
                />,
              )}
            </Grid2>
          </>
        )
      }
    </>
  );
};

export default NotificationForm;
